import { endpoints, host } from '@config/endpoints';
import axios, { CancelTokenSource } from 'axios';
import request, { Cancelled } from './request';

var getHeatMapInfoCancelToken: CancelTokenSource;

export const getHeatMapInfo = async (HubIds: string[], locations: string[], fromQuarter: string, toQuarter: string, isEntryLevel: boolean) => {
    const { path, method } = endpoints.heatMap.getHeatMapInfo;

    getHeatMapInfoCancelToken && getHeatMapInfoCancelToken.cancel();
    const source = axios.CancelToken.source();
    getHeatMapInfoCancelToken = source;

    let err = null;
    let res: any = null;
    let options = {};
    if (getHeatMapInfoCancelToken.token)
        options = { cancelToken: getHeatMapInfoCancelToken.token };

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, locations, fromQuarter, toQuarter, isEntryLevel },
            options,
        ));
    } catch (error) {
        if (axios.isCancel(error)) {
            err = Cancelled;
        }
        else {
            // @ts-ignore
            err = error.message;
        }
    }

    return [err, res];
};
